import { CircularProgress, Card, Box, CardContent, useTheme, Typography, Grid, TextField, Button, Paper } from "@mui/material";
import React, { useState, useEffect } from "react";

import { tokens } from "../../theme";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import { djangoApi } from "../../utils/axios/axios.utils";

import { useDispatch } from "react-redux";
import { updateProds } from "../../store/products/products.action";
import SemProduto from "../../assets/img/produto-sem-imagem.jpg"
import styles from './prods.module.css'

const EditableProductCard = ({ product, onSave, handleClose }) => {
    console.log('prod Here: ', product)
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const dispatch = useDispatch()
    const MySwal = withReactContent(Swal);

    const [editedProduct, setEditedProduct] = useState(product);
    const [isLoading, setIsLoading] = useState(false);
    const [hasError, setHasError] = useState(false);

    const [isHovered, setIsHovered] = useState(false);

    const handleInputChange = (event) => {
        const { name, value, type } = event.target;
        setEditedProduct((prev) => ({
            ...prev,
            [name]: type === "number" ? Number(value) : value,
        }));
    };

    const updateProd = async (prodData) => {
        const params = JSON.stringify(prodData)
        setIsLoading(true)
        try {
            const res = await djangoApi
                .post(`products/register_prods/${prodData.pk}/update_single_product/`, params, {
                    headers: {
                        Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                        "Content-Type": "application/json"
                    }
                })
            console.log('res: ', res)
            const { data, } = res.data
            dispatch(updateProds(data))

            setIsLoading(false)
            const objToReturn = {
                status: res.status,
            }
            return objToReturn
        } catch (err) {
            console.log("Erro ao alterar as aplicações", err);
            window.alert(err);
            setIsLoading(false)
        } finally {
            // pass
            setIsLoading(false)
        }
    };
    const handleSave = async () => {
        // TODO
        // create the logic to update price prod
        const res = await updateProd(editedProduct)
        if (res.status === 201) {
            handleClose()
            MySwal.fire("Feito!!", `Produto Alterado com sucesso!!`, "success").then(() => {
                // Code to execute after the alert is confirmed
                // For example, redirect to another page or refresh data
            })
        } else {
            handleClose()
            MySwal.fire("Problema!!", `Problema para alterar o produto!!`, "error").then(() => {
                // Code to execute after the alert is confirmed
                // For example, redirect to another page or refresh data
            })
        }
        // // onSave(editedProduct); // Call the onSave function to save the changes
    };

    const inputStyle = {
        "& .MuiOutlinedInput-root": {
            "&:hover fieldset": {
                borderColor: "white", // Hover border color
            },
            "&.Mui-focused fieldset": {
                borderColor: "white", // Focused border color

            },
        },
        "& .MuiInputLabel-root": {
            color: "white", // Default label color
        },
        "& .MuiInputLabel-root.Mui-focused": {
            color: "white", // Focused label color
        },
    }

    const handleImageError = (event) => {
        event.target.src = SemProduto; // Fallback to the placeholder on error
        setHasError(true)
    };

    // Function to close large image
    const closeImage = () => {
        setIsHovered(false);
    };

    // Close image on key press
    useEffect(() => {
        const handleKeyPress = (event) => {
            closeImage(); // Only closes the enlarged image
        };

        window.addEventListener("keydown", handleKeyPress);

        return () => {
            window.removeEventListener("keydown", handleKeyPress);
        };
    }, []);

    const handleHover = () => {
        setIsHovered(prev => !prev);
    };

    return (
        <Paper component={Card} variant="outlined" style={{ margin: "16px", backgroundColor: colors.pink[900] }} >

            <CardContent>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}
                >

                    <Typography variant="h5" component="div" sx={{ marginBottom: '30px' }}>
                        {editedProduct.id_produto}
                    </Typography>
                    <div
                        className={styles.container}
                        onClick={() => handleHover()}
                    // onMouseLeave={() => setIsHovered(false)}
                    >

                        <Box
                            component="img"
                            src={editedProduct?.imageUrl || SemProduto}
                            alt={editedProduct?.id_produto}
                            // className={styles.smallImage}
                            sx={{
                                width: '100px',
                                height: '100px',
                                marginBottom: '15px',
                                borderRadius: '12px'
                            }}
                            onError={handleImageError}
                        />
                        {isHovered && !hasError && (
                            <div className={styles.backdrop}>
                                <Box
                                    component="img"
                                    src={editedProduct?.imageUrl || SemProduto}
                                    alt={editedProduct?.id_produto}
                                    className={styles.largeImage}
                                />
                            </div>
                        )}
                    </div>

                </Box>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            disabled
                            label="Fornecedor"
                            variant="outlined"
                            fullWidth
                            name="supplier__name"
                            value={editedProduct.supplier__name}
                            onChange={handleInputChange}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            disabled
                            label="ID Fornecedor"
                            variant="outlined"
                            fullWidth
                            name="id_supplier"
                            value={editedProduct.id_supplier}
                            onChange={handleInputChange}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            disabled
                            label="Cor"
                            variant="outlined"
                            fullWidth
                            name="color__color"
                            value={editedProduct.color__color}
                            onChange={handleInputChange}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            disabled
                            label="Modelo"
                            variant="outlined"
                            fullWidth
                            name="model"
                            value={editedProduct.model}
                            onChange={handleInputChange}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            // disabled
                            label="Inventário Inicial"
                            variant="outlined"
                            fullWidth
                            type="number"
                            name="initial_inventory"
                            value={editedProduct.initial_inventory}
                            onChange={handleInputChange}
                            sx={inputStyle}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            // disabled
                            label="Quantidade Disponível"
                            variant="outlined"
                            fullWidth
                            type="number"
                            name="quantity_available"
                            value={editedProduct.quantity_available}
                            onChange={handleInputChange}
                            sx={inputStyle}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            disabled
                            label="Ródio B"
                            variant="outlined"
                            fullWidth
                            type="number"
                            name="rodio_b"
                            value={editedProduct.rodio_b || 'N/A'}
                            onChange={handleInputChange}
                            sx={inputStyle}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            disabled
                            label="Ródio N"
                            variant="outlined"
                            fullWidth
                            type="number"
                            name="rodio_n"
                            value={editedProduct.rodio_n || 'N/A'}
                            onChange={handleInputChange}
                            sx={inputStyle}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            // disabled
                            label="Preço de Custo"
                            variant="outlined"
                            fullWidth
                            type="number"
                            name="cost_price"
                            value={editedProduct.cost_price}
                            onChange={handleInputChange}
                            sx={inputStyle}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            // disabled
                            label="Preço Cobrado"
                            variant="outlined"
                            fullWidth
                            type="number"
                            name="charged_price"
                            value={editedProduct.charged_price}
                            onChange={handleInputChange}
                            sx={inputStyle}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            disabled
                            label="Data de Compra"
                            variant="outlined"
                            fullWidth
                            type="date"
                            name="purchase_date"
                            value={editedProduct.purchase_date.split("T")[0]} // Format to "YYYY-MM-DD"
                            onChange={handleInputChange}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            disabled
                            label="Estilo"
                            variant="outlined"
                            fullWidth
                            name="style"
                            value={editedProduct.style || ""}
                            onChange={handleInputChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            disabled
                            label="Tamanho"
                            variant="outlined"
                            fullWidth
                            name="style"
                            value={editedProduct.tamanho || ""}
                            onChange={handleInputChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            disabled
                            label="peso"
                            variant="outlined"
                            fullWidth
                            name="style"
                            value={editedProduct?.weight || ""}
                            onChange={handleInputChange}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            label="Detalhes"
                            variant="outlined"
                            fullWidth
                            name="detailing"
                            value={editedProduct.detailing || ""}
                            onChange={handleInputChange}
                            sx={inputStyle}
                        />
                    </Grid>
                </Grid>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        width: '100%',
                        justifyContent: 'flex-end',
                        gap: '20px'
                    }}
                >
                    <Button
                        variant="contained"
                        color="warning"
                        style={{ marginTop: "16px", color: 'whitesmoke' }}
                        onClick={() => handleClose()}
                        disabled={isLoading}  // Disable the button while loading
                    >
                        Cancelar
                    </Button>
                    <Button
                        variant="contained"
                        color="success"
                        style={{ marginTop: "16px", color: 'whitesmoke' }}
                        onClick={handleSave}
                        disabled={isLoading}  // Disable the button while loading
                        startIcon={isLoading ? <CircularProgress size={16} style={{ color: 'whitesmoke' }} /> : null}
                    >
                        Salvar Alterações
                    </Button>
                </Box>
            </CardContent>

        </Paper>
    );
};

export default EditableProductCard;